


export function ShareLoadingState() {
  return (
    <div className="flex flex-col justify-center items-center py-6 space-y-4">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      <p className="text-sm text-muted-foreground">Creating shareable link...</p>
    </div>
  );
}
